import styled from "styled-components";

interface IFilesList {
  height?: string;
  width?: string;
}
export const FilesList = styled.div<IFilesList>`
  height: ${(props) => (props.height ? props.height : "auto")};
  margin-top: 2.6rem;
  width: ${(props) => (props.width ? props.width : "auto")};
`;

export const FileInfo = styled.div`
  align-items: center;
  border-color: transparent;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 5px 20px rgb(231 231 234 / 62%);
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  height: 4.8rem;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 0 1rem;
  width: 52.2rem;

  div {
    align-items: center;
    display: grid;
    gap: 1.3rem;
    grid-template-columns: 1.5rem 1fr 6rem;
  }

  .delete-icon {
    cursor: pointer;
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(106deg) brightness(30%)
      contrast(105%);
  }

  .download-icon {
    cursor: pointer;
  }

  p {
    margin-left: 1rem;
  }

  .size {
    color: ${(props) => props.theme.colors.gray72};
    font-weight: 500;
  }

  .icons {
    display: flex;
    justify-content: flex-end;
  }
`;

export const RowContainer = styled.div`
  border-radius: 8px;
  border: 1px dashed #002e6c;
  cursor: pointer;
  height: 4.8rem;
  margin-top: 2.6rem;
  width: 52.2rem;
  p {
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
    font-weight: 500;
  }

  img {
    padding: 0.5rem;
  }
`;

export const DashedRow = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextTitle};
  display: flex;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.2rem;
  font-weight: 500;
  justify-content: center;
  padding: 0.6rem 0;
`;
